<template lang="pug">
.Logo
  span M
  span ©
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style lang="scss">
.Logo {
  text-decoration: none;
  font-weight: bold;
  font-size: $fs-xl;
  margin: 0;
  line-height: 0.9em;
  text-align: center;
  padding-top: $margins-m;

  span {
    display: block;
  }

  @include desktop {
    text-align: left;
    padding-top: $margins-d;

    span {
      display: inline;
    }
  }
}
</style>
